import { useNavigate } from "react-router";

import Info from "@zenith/assets/icons/Info";
import { GreenTick } from "@zenith/assets/icons/components";
import { MajorButtonComponent } from "@zenith/components";
import { DASHBOARD } from "@zenith/routes/paths";
import { useLoansContext } from "@zenith/context/global-context/hooks";
import { formatCurrency } from "@zenith/utils";
import { memo } from "react";

/* eslint-disable-next-line */
export interface LoansSuccessfulPageProps {}

const LoansSuccessfulPage = memo(function LoansSuccessfulPage(
  props: LoansSuccessfulPageProps
) {
  const {
    loansContext: {
      duration,
      interestRate,
      loanRepay,
      loanRequested,
      packageName,
    },
    clearLoansContext,
  } = useLoansContext();
  const navigate = useNavigate();

  function handleGoToDashboard() {
    clearLoansContext();
    navigate(DASHBOARD);
  }

  return (
    <div className="mb-2 mt-12 flex min-h-[calc(100vh-250px)] max-w-[96%] flex-col justify-around">
      <div className="flex w-[668px] max-w-[98%] flex-col items-center self-center rounded-[20px] border border-neutral-200">
        <div className="flex w-full flex-col justify-center gap-1 p-8">
          <div>
            <div className="my-9 flex justify-center">
              <GreenTick transform="scale(3)" />
            </div>
            <h2 className="text-charcoal-black mb-8 text-center text-xl font-medium leading-relaxed">
              Request Submitted With Success
            </h2>
          </div>
          <div className="mb-8 flex h-14 w-full items-start justify-between rounded-lg bg-indigo-600 bg-opacity-5 p-4">
            <div className="flex h-6 shrink grow basis-0 items-center justify-start gap-2.5">
              <div className="flex h-6 w-6 items-center justify-center p-1">
                <Info fill="#5656CA" />
              </div>
              <div className="shrink grow basis-0 text-sm font-normal leading-none text-zinc-900">
                You will be contacted by the bank within 24-48 hours
              </div>
            </div>
          </div>

          <hr className="my-4 border-t-1 border-neutral-200" />

          <h2 className="text-xl font-medium leading-7 text-zinc-900">
            {packageName}
          </h2>

          <div className="mb-2 flex justify-between">
            <p className="text-neutral-600">Loan Requested</p>
            <p>{formatCurrency(loanRequested)}</p>
          </div>
          <div className="mb-2 flex justify-between">
            <p className="text-neutral-600">Loan Repay</p>
            <p>{formatCurrency(loanRepay)}</p>
          </div>

          <hr className="my-4 border-t-1 border-neutral-200" />

          <div className="mb-2 flex justify-between">
            <p className="text-neutral-600">Interest Rate</p>
            <p>{interestRate} %</p>
          </div>
          <div className="mb-2 flex justify-between">
            <p className="text-neutral-600">Duration</p>
            <p className="capitalize">{duration.toLowerCase()}</p>
          </div>

          <hr className="my-4 border-t-1 border-gray-200" />

          <div className="flex w-full items-center justify-center">
            <MajorButtonComponent
              id="loans-success-go-to-dashboard"
              buttonType="primary"
              size="large"
              onClick={handleGoToDashboard}
              type={"button"}
              className="mt-10 items-center"
            >
              Go to Dashboard
            </MajorButtonComponent>
          </div>
        </div>
      </div>
    </div>
  );
});

export default LoansSuccessfulPage;
